<template>
  <div>
    <div class="box1 mb25">
      <div class="item">
        <div class="info">
          <div class="t1">{{ countReactive.data.play_count }}</div>
          <div class="t2">总播放量</div>
        </div>
      </div>
      <div class="item">
        <div class="info">
          <div class="t1">{{ countReactive.data.fans_count }}</div>
          <div class="t2">总粉丝数</div>
        </div>
      </div>
      <div class="item">
        <div class="info">
          <div class="t1">{{ countReactive.data.digg_count }}</div>
          <div class="t2">总点赞数</div>
        </div>
      </div>
      <div class="item">
        <div class="info">
          <div class="t1">{{ countReactive.data.comment_count }}</div>
          <div class="t2">总评论数</div>
        </div>
      </div>
      <div class="item">
        <div class="info">
          <div class="t1">
            {{ countReactive.data.user_intention_dialogue_count }}
          </div>
          <div class="t2">总私信数</div>
        </div>
      </div>
    </div>
    <el-row :gutter="20" class="box2">
      <el-col :span="7">
        <div class="box b1">
          <div class="title">视频创作</div>
          <div class="desc">通过文本 碎片化素材生成优质视频</div>
          <div class="btn" @click="router.push('/video_ai_task')">
            去创作
            <img src="@/assets/img/index/6.png" />
          </div>
        </div>
      </el-col>
      <el-col :span="10">
        <div class="box b2 mb20" style="height: 180px">
          <div class="title">图文创作</div>
          <div class="desc">自动化文案生成 配合图集生成创作内容</div>
          <div
            class="btn small"
            @click="router.push('/v2_image_text_task_manage')"
          >
            去创作
            <img src="@/assets/img/index/6.png" />
          </div>
        </div>
        <div class="box b3" style="height: 180px">
          <div class="title">七秒爆款</div>
          <div class="desc">通过IP人设片段和情绪化文案，打造爆款视频</div>
          <div class="btn small" @click="router.push('/seven_seconds_list')">
            去创作
            <img src="@/assets/img/index/6.png" />
          </div>
        </div>
      </el-col>
      <el-col :span="7">
        <div class="box">
          <el-row class="mb25" justify="space-between" align="middle">
            <div class="title mb0">
              套餐额度
              <img class="ml10" src="@/assets/img/index/7.png" />
            </div>
            <div class="desc end_time">
              会员到期时间: {{ userInfo.end_time.split(' ')[0] }}
            </div>
          </el-row>
          <div class="progress">
            <el-row justify="space-between" align="middle">
              <div>账号额度</div>
              <div>
                {{ reactiveData.count_list.count1 }}/{{
                  percentageComputed1Denominator
                }}
              </div>
            </el-row>
            <el-progress
              :stroke-width="12"
              :percentage="percentageComputed1"
              :show-text="false"
            />
          </div>
          <div class="progress">
            <el-row justify="space-between" align="middle">
              <div>视频今日发布额度</div>
              <div>
                {{ percentageComputed2Numerator }}/{{
                  userInfo.video_daily_release_count
                }}
              </div>
            </el-row>
            <el-progress
              :stroke-width="12"
              :percentage="percentageComputed2"
              :show-text="false"
            />
          </div>
          <div class="progress">
            <el-row justify="space-between" align="middle">
              <div>图文今日发布额度</div>
              <div>
                {{ percentageComputed3Numerator }}/{{
                  userInfo.image_daily_release_count
                }}
              </div>
            </el-row>
            <el-progress
              :stroke-width="12"
              :percentage="percentageComputed3"
              :show-text="false"
            />
          </div>
          <div class="progress">
            <el-row justify="space-between" align="middle">
              <div>剪辑数量</div>
              <div>
                {{ reactiveData.count_list.count3 }}/{{
                  userInfo.video_task_max_count
                }}
              </div>
            </el-row>
            <el-progress
              :stroke-width="12"
              :percentage="percentageComputed4"
              :show-text="false"
            />
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20" class="tbox">
      <el-col :span="7">
        <div class="box">
          <div class="title">运营建议</div>
          <el-timeline class="timeline">
            <el-timeline-item hide-timestamp center>
              <template #dot>
                <img src="@/assets/img/index/11.png" />
              </template>
              <el-space>
                <img src="@/assets/img/index/12.png" />
                <div>
                  <div>认证两个蓝v账号,并绑定</div>
                  <div>
                    进入
                    <el-link
                      class="link_baseline"
                      type="primary"
                      :underline="false"
                      href="https://e.douyin.com/site/douyin-mp/login"
                      target="_blank"
                    >
                      立即认证
                    </el-link>
                    ,点击立即认证按要求进行填写
                  </div>
                </div>
              </el-space>
            </el-timeline-item>
            <el-timeline-item hide-timestamp center>
              <template #dot>
                <img src="@/assets/img/index/11.png" />
              </template>
              <el-space>
                <img src="@/assets/img/index/13.png" />
                <div>
                  <div>装修蓝v账号</div>
                  <div>头像、顶图、介绍、电话、地址、商家主页</div>
                </div>
              </el-space>
            </el-timeline-item>
            <el-timeline-item hide-timestamp center>
              <template #dot>
                <img src="@/assets/img/index/11.png" />
              </template>
              <el-space>
                <img src="@/assets/img/index/14.png" />
                <div>
                  <div>账户SEO设置</div>
                  <div>将产品关键词进行布局,可以使用工具箱里面的拓词工具</div>
                </div>
              </el-space>
            </el-timeline-item>
            <el-timeline-item hide-timestamp center>
              <template #dot>
                <img src="@/assets/img/index/11.png" />
              </template>
              <el-space>
                <img src="@/assets/img/index/15.png" />
                <div>
                  <div>设置智能发布、每个账号每天建议发布两个视频</div>
                  <div>每个账号每天发布2个视频,保持更新不间断</div>
                </div>
              </el-space>
            </el-timeline-item>
            <el-timeline-item hide-timestamp center>
              <template #dot>
                <img src="@/assets/img/index/11.png" />
              </template>
              <el-space>
                <img src="@/assets/img/index/16.png" />
                <div>
                  <div>绑定微信,接收意向客户提醒</div>
                  <div>可接收信息流/企业号线索/私信询盘</div>
                </div>
              </el-space>
            </el-timeline-item>
          </el-timeline>
        </div>
      </el-col>
      <el-col
        :span="10"
        :style="{ marginBottom: isMobileObj.any ? '20px' : 0 }"
      >
        <div class="box pt15">
          <div class="title mb0">作品播放量</div>
          <div class="doughnut_box">
            <ChartDoughnut
              :chartData="reactiveData.chartDataDoughnut"
              style="
                width: 100%;
                height: 275px;
                max-width: 700px;
                margin: 0 auto;
              "
            />
          </div>
        </div>
      </el-col>
      <el-col :span="7">
        <div class="box">
          <div class="title">常用工具</div>
          <div class="tools mt50">
            <div class="list">
              <div class="item" @click="reactivePopupTool1.visible = true">
                <img src="@/assets/img/tools_icon1.png" />
                <div>客户端下载</div>
              </div>
              <!-- <a
                class="item"
                href="/upload/chrome-xtensions.zip"
                target="_blank"
              >
                <div>
                  <img src="@/assets/img/tools_icon2.png" />
                  <div>授权插件</div>
                </div>
              </a> -->
              <div class="item" @click="reactivePopupTool3.visible = true">
                <img src="@/assets/img/tools_icon3.png" />
                <div>拓词工具</div>
              </div>
              <div class="item" @click="reactivePopupTool4.visible = true">
                <img src="@/assets/img/tools_icon4.png" />
                <div>视频提取</div>
              </div>
              <div class="item" @click="reactivePopupTool5.visible = true">
                <img src="@/assets/img/tools_icon5.png" />
                <div>BGM提取</div>
              </div>
              <!-- <div class="item" @click="reactivePopupTool6.visible = true">
                <img src="@/assets/img/tools_icon8.png" />
                <div>chatGPT</div>
              </div> -->
              <!-- <div class="item" @click="reactivePopupTool7.visible = true">
                <img src="@/assets/img/tools_icon9.png" />
                <div>DeepSeek</div>
              </div> -->
              <div class="item" @click="reactivePopupTool8.visible = true">
                <img src="@/assets/img/tools_icon9.png" />
                <div>DeepSeek</div>
              </div>
              <a
                class="item"
                :href="reactiveData.case_url"
                target="_blank"
                v-show="reactiveData.case_url"
              >
                <div>
                  <img src="@/assets/img/tools_icon7.png" />
                  <div>综合报表</div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div class="box">
          <div class="title">数据统计</div>
          <ChartLine :chartData="reactiveData.chartDataLine" />
        </div>
      </el-col>
    </el-row>
    <canvas ref="canvasRef" style="display: none"></canvas>
    <PopupTool1 v-model="reactivePopupTool1.visible" />
    <PopupTool3 v-model="reactivePopupTool3.visible" />
    <PopupTool4 v-model="reactivePopupTool4.visible" />
    <PopupTool5 v-model="reactivePopupTool5.visible" />
    <PopupTool6 v-model="reactivePopupTool6.visible" />
    <PopupTool7 v-model="reactivePopupTool7.visible" />
    <PopupTool8 v-model="reactivePopupTool8.visible" />
  </div>
</template>

<script setup>
import { reactive, ref, toRefs, computed, watchEffect } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import moment from 'moment'
import isMobile from 'ismobilejs'
import {
  new_index_data,
  new_index_count,
  weekdata,
  v2_video_new_release_video_play_count,
} from '@/utils/api'
import ChartDoughnut from '@/components/ChartDoughnut'
import ChartLine from '@/components/ChartLine'
import PopupTool1 from '@/components/PopupTool1'
import PopupTool3 from '@/components/PopupTool3'
import PopupTool4 from '@/components/PopupTool4'
import PopupTool5 from '@/components/PopupTool5'
import PopupTool6 from '@/components/PopupTool6'
import PopupTool7 from '@/components/PopupTool7'
import PopupTool8 from '@/components/PopupTool8'

const store = useStore()
const { state } = store
const { userInfo } = toRefs(state)

const router = useRouter()

const isMobileObj = isMobile(window.navigator)

const reactiveData = reactive({
  chartDataDoughnut: {},
  chartDataLine: {},
  case_url: '',
  count_list: {
    count1: 0,
    count2: 0,
    count3: 0,
    count_list_count2_1: 0,
    count_list_count2_2: 0,
    count_list_count2_3: 0,
    count_list_count2_4: 0,
  },
  play_count: {
    1: 0,
    2: 0,
    3: 0,
    5: 0,
    6: 0,
    9: 0,
    10: 0,
  },
})

new_index_data().then(({ data: res }) => {
  Object.assign(reactiveData, res.data)
})

const canvasRef = ref()

weekdata().then(({ data: res }) => {
  let gradient1 = canvasRef.value
    .getContext('2d')
    .createLinearGradient(0, 0, 0, 450)
  let gradient2 = canvasRef.value
    .getContext('2d')
    .createLinearGradient(0, 0, 0, 450)

  gradient1.addColorStop(0, 'rgba(1, 111, 237, 0.2)')
  gradient1.addColorStop(1, 'rgba(1, 111, 237, 0)')
  gradient2.addColorStop(0, 'rgba(237,166,0, 0.2)')
  gradient2.addColorStop(1, 'rgba(237,166,0, 0)')

  reactiveData.chartDataLine = {
    labels: res.data.daylist,
    datasets: [
      {
        label: '曝光量',
        borderWidth: 3,
        borderColor: '#016FED',
        backgroundColor: gradient1,
        fill: true,
        tension: 0,
        data: res.data.datalist,
      },
      {
        label: '作品量',
        borderWidth: 3,
        borderColor: '#EDA600',
        backgroundColor: gradient2,
        fill: true,
        tension: 0,
        data: res.data.datalist1,
      },
    ],
  }
})

const reactivePopupTool1 = reactive({
  visible: false,
})

const reactivePopupTool3 = reactive({
  visible: false,
})

const reactivePopupTool4 = reactive({
  visible: false,
})

const reactivePopupTool5 = reactive({
  visible: false,
})

const reactivePopupTool6 = reactive({
  visible: false,
})

const reactivePopupTool7 = reactive({
  visible: false,
})

const reactivePopupTool8 = reactive({
  visible: false,
})

const countReactive = reactive({
  active: {},
  data: {
    fans_count: 0,
    video_count: 0,
    play_count: 0,
    digg_count: 0,
    comment_count: 0,
    user_intention_dialogue_count: 0,
  },
})

watchEffect((onInvalidate) => {
  const controller = new AbortController()
  new_index_count(
    { aid: countReactive.active.id },
    { signal: controller.signal }
  ).then(({ data: res }) => {
    countReactive.data = res.data
  })
  onInvalidate(() => {
    controller.abort()
  })
})

const percentageComputed1Denominator = computed(
  () =>
    userInfo.value.douyin_max_count +
    userInfo.value.douyin_employee_max_count +
    userInfo.value.douyin_enterprise_max_count +
    userInfo.value.kuaishou_max_count +
    userInfo.value.shipinhao_max_count +
    userInfo.value.xiaohongshu_max_count +
    userInfo.value.bilibili_max_count +
    userInfo.value.toutiao_max_count +
    userInfo.value.haokan_max_count
)
const percentageComputed1 = computed(
  () =>
    (reactiveData.count_list.count1 / percentageComputed1Denominator.value) *
    100
)
const percentageComputed2Numerator = computed(
  () =>
    reactiveData.count_list.count_list_count2_1 +
    reactiveData.count_list.count_list_count2_4
)
const percentageComputed2 = computed(
  () =>
    (percentageComputed2Numerator.value /
      userInfo.value.video_daily_release_count) *
    100
)
const percentageComputed3Numerator = computed(
  () =>
    reactiveData.count_list.count_list_count2_2 +
    reactiveData.count_list.count_list_count2_3
)
const percentageComputed3 = computed(
  () =>
    (percentageComputed3Numerator.value /
      userInfo.value.image_daily_release_count) *
    100
)
const percentageComputed4 = computed(
  () =>
    (reactiveData.count_list.count3 / userInfo.value.video_task_max_count) * 100
)

watchEffect((onInvalidate) => {
  const controller = new AbortController()
  v2_video_new_release_video_play_count({}, { signal: controller.signal }).then(
    ({ data: res }) => {
      reactiveData.chartDataDoughnut = res.chartData
    }
  )
  onInvalidate(() => {
    controller.abort()
  })
})
</script>

<style scoped lang="scss">
@import '@/assets/css/color.scss';

$box1: 1 #51b6f9 #5092f3, 2 #feb252 #ff7c5c, 3 #ffc507 #fdac02,
  4 #00d6ff #00bbff, 5 #8c96fd #6978fe;
.box1 {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 25px;
  .item {
    height: 90px;
    border-radius: 10px;
    padding: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .t1 {
      font-weight: bold;
      font-size: 32px;
      line-height: 1.5;
    }
    .t2 {
      font-size: 14px;
    }
  }
  @each $index, $color1, $color1 in $box1 {
    .item:nth-child(#{$index}) {
      background-color: $color1;
      background-image: url('@/assets/img/index/1920/#{$index}.png');
      background-size: cover;
      background-position: center;
      &::after {
        content: '';
        width: 44px;
        height: 44px;
        background: url('@/assets/img/index/#{$index}.png');
      }
    }
  }
}
.box2 {
  .box {
    height: 380px;
    position: relative;
    .btn {
      position: absolute;
      left: 20px;
      bottom: 15px;
    }
    &.b1 {
      background: url('@/assets/img/index/8.png') no-repeat right 40px center;
    }
    &.b2 {
      background: url('@/assets/img/index/9.png') no-repeat right 40px center;
    }
    &.b3 {
      background: url('@/assets/img/index/10.png') no-repeat right 40px center;
    }
  }
  .desc {
    color: #b3b3cb;
    font-size: 16px;
  }
  .btn {
    cursor: pointer;
    width: 240px;
    height: 50px;
    border-radius: 25px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 18px;
    background: linear-gradient(#3c6be6, #254cb2);

    &:hover {
      background: linear-gradient(#adc4ff, #477aff);
    }
    &.small {
      width: 180px;
      height: 36px;
      border-radius: 18px;
      font-size: 16px;
    }
    img {
      margin-left: 20px;
    }
  }

  .progress {
    margin-bottom: 30px;
    :deep(.el-progress-bar__inner) {
      background: linear-gradient(to right, #71e2ff, #1d62fe);
    }
    .el-row {
      margin-bottom: 10px;
      color: #b4b4ce;
    }
  }
}
.el-row {
  margin-bottom: 20px;
}
.tbox {
  .box {
    height: 550px;
  }
}
.doughnut_box {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 120px;
  padding-right: 20px;
  margin-left: -20px;
  margin-right: -20px;

  canvas::after {
    content: '';
    width: 229px;
    height: 229px;
    border-radius: 50%;
    background-color: #0e2e5b;
    position: absolute;
    z-index: -1;
  }
}

.tools {
  position: relative;
  .list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    row-gap: 40px;
    .item {
      flex: 1;
      /* padding: 0 75px; */
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 18px;
      cursor: pointer;
      img {
        margin-bottom: 15px;
      }
    }
  }
}

.timeline {
  :deep(.el-timeline-item) {
    padding-bottom: 50px;
    .el-timeline-item__dot {
      left: -6px;
    }
    .el-space__item {
      line-height: 1.4;
    }
  }
}

@media screen and (max-width: 2560px) {
  .box1 {
    @each $index, $color1, $color1 in $box1 {
      .item:nth-child(#{$index}) {
        background-image: url('@/assets/img/index/2560/#{$index}.png');
      }
    }
  }
}

@media screen and (max-width: 1920px) {
  .box1 {
    @each $index, $color1, $color1 in $box1 {
      .item:nth-child(#{$index}) {
        background-image: url('@/assets/img/index/1920/#{$index}.png');
      }
    }
  }
}

@media screen and (max-width: 1366px) {
  .box1 {
    @each $index, $color1, $color1 in $box1 {
      .item:nth-child(#{$index}) {
        background-image: url('@/assets/img/index/1366/#{$index}.png');
      }
    }
  }
  .box2 {
    .box {
      &.b1 {
        background-position: center;
      }
      &.b2,
      &.b3 {
        background: none;
      }
    }
    .desc.end_time {
      display: none;
    }
  }
  .timeline {
    :deep(.el-timeline-item) {
      padding-bottom: 24px;
    }
  }
  .doughnut_box {
    padding-right: 0;
  }
}

@media screen and (max-width: 1440px) {
  .box_1440_1 {
    max-width: 30%;
    flex: 0 0 30%;
    .doughnut_box {
      margin-left: 10%;
    }
  }
  .box_1440_2 {
    max-width: 30%;
    flex: 0 0 30%;
  }
  .box_1440_3 {
    max-width: 40%;
    flex: 0 0 40%;
  }
}

@media screen and (max-width: 768px) {
  .box_1440_1 {
    max-width: 100%;
    flex: 0 0 100%;
    .doughnut_box {
      margin-left: 10%;
    }
  }
  .box_1440_2 {
    max-width: 100%;
    flex: 0 0 100%;
    margin-bottom: 20px;
  }
  .box_1440_3 {
    max-width: 100%;
    flex: 0 0 100%;
  }
}
</style>
